
<div class="threedviewer">
    
    <div class="stage-box" *ngIf="(hasPDBData === 1 || hasAFDBData === 1) && !isStructureFail && (isPDBFoldseekCach === true && isAFDBFoldseekCach === true)">
        <div class="frame-parent">
            <div class="be-the-first-to-explore-parent"> 
                <div class="struct-table-wrapper">
                    <div class="struct-table">
                        <mat-tab-group #tabGroup (selectedTabChange)="tabChanged($event)">

                            <mat-tab class="mat-tab-title" [label]="''" [disabled]="isPDBLoading">
                                <ng-template mat-tab-label>
                                    PDB structures&nbsp;
                                    <span *ngIf="!isPDBLoading">
                                    ({{ totalStructure }})
                                    </span>
                                    <!-- Spinner shown only when isPDBLoading is true -->
                                    <span *ngIf="isPDBLoading"  style="display: inline-block; width: 20px; margin-left: 8px;">
                                    <svg  width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
                                    </svg>
                                    </span>
                                </ng-template>


                                <div *ngIf="pdbZeroResultsMsg !== ''" class="threedViewer structureContainer mobile-error-msg fullwidth">
                                    <p *ngIf="hasPDBData === -1 && totalStructure == 0" class="noRecMsg">{{ pdbZeroResultsMsg }} </p>
                                </div>

                                <div class="download-first-row" *ngIf="pdbZeroResultsMsg === ''">
                                    <span> Best match displayed first</span>
                                </div>
                               
                                <div  *ngIf="pdbZeroResultsMsg === ''">
                                  
                                    <table
                                        mat-table
                                        [dataSource]="pdbStructureDataSource"
                                        class="mat-elevation-z8 structureTable"
                                        matSort
                                        matSortActive="evalue"
                                        matSortDirection="desc"
                                        (matSortChange)="sortTable($event, 'pdb')"
                                        matSortDisableClear
                                        multiTemplateDataRows
                                    >
                                    
                                    <ng-container matColumnDef="select">
                                        <th mat-header-cell *matHeaderCellDef class="nonMobile">
                                          <input
                                            type="checkbox"
                                            id="select-all-checkbox"
                                            class="vf-form__checkbox"
                                            [checked]="allSelectedPDB()"
                                            [disabled]="isLimitReachedPDB"
                                            (change)="toggleSelectAllEntries($event, 'pdb')"
                                          />
                                          <label for="select-all-checkbox" class="vf-form__label"></label>
                                        </th>
                                        <td mat-cell *matCellDef="let element" class="nonMobile">
                                            <input
                                            type="checkbox"
                                            id="row-checkbox-{{ element.targetToShow }}"
                                            class="vf-form__checkbox"
                                            [checked]="selectionPDB.has(element.targetToShow)"
                                            [disabled]="isRowCheckboxDisabledPDB() && !selectionPDB.has(element.targetToShow)"
                                            (change)="toggleSingleRowSelection($event, element.targetToShow, 'pdb')"
                                          />
                                          <label for="row-checkbox-{{ element.targetToShow }}" class="vf-form__label"></label>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="expand">
                                        <th class="firstexpandpdb arrow" mat-header-cell *matHeaderCellDef></th>
                                        <td  mat-cell *matCellDef="let element" class="arrow-box" [ngClass]="!isExpanded(element) ? '' : 'arrow-active'">
                                           
                                            <div class="mobile-view">
                                                <div class="mobile-wrapfirsttd">
                                                    <button (click)="toggleRowPDB(element); $event.stopPropagation()"  mat-icon-button aria-label="expand row" class="icon-button">
                                                        <span *ngIf="!isExpanded(element)" class="mobile-arrow-title-text"> Open pairwise alignment  <img *ngIf="!isExpanded(element)" src="assets/img/down-arrow.svg" alt="uparrow" class="newimg"></span>
                                                        <span *ngIf="isExpanded(element)" class="mobile-arrow-title-text"> Close pairwise alignment   <img  src="assets/img/arrow-dropping.svg" alt="downarrow" class="newimg"></span>
    
                                                    </button>
    
                                                    
                                                </div>
                                            </div>
                                        </td>
                                    </ng-container>

                                   
                                    <ng-container matColumnDef="expandedDetail">
                                        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsStructureWithExpand.length" class="expand-column">
                                          <div class="example-element-detail" *ngIf="isExpanded(element)">
                                            <app-sequence-card [hsps]="element.hsps" [isExpandStructure]="true"></app-sequence-card>
                                          </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="alighin3D">
                                        <th class="eight-align" mat-header-cell *matHeaderCellDef>
                                           
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                           
                                            <div class="switch-af"> <span class="mobile-view-title">Align in 3D</span>
                                                <input type="checkbox" [disabled]="disabledState[element.afdbAccessions.split('*')[0]] || false" [checked]="checkboxState[element.afdbAccessions.split('*')[0]] || false" id="{{element.afdbAccessions.split('*')[0]}}" value="{{element.afdbAccessions.split('*')[0]}}" (change)="superposeSliderToggle($event,element.afdbAccessions.split('*')[0]); $event.stopPropagation();" />
                                                <label (click)="$event.stopPropagation();" for="{{element.afdbAccessions.split('*')[0]}}">
                                                
                                                <img src="../../assets/img/FatX.svg" alt="FatX" class="unchecked-icon">
                                                <img src="../../assets/img/base-switch_icon.svg" alt="check" class="checked-icon">

                                                </label>
                                            </div>
                                        </td>
                                    </ng-container>
                                   
                                    <ng-container matColumnDef="afdbAccessions">
                                        <th class="first-pdbid" mat-header-cell *matHeaderCellDef>
                                           <span>PDB ID <br>and chain</span>
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                        <span class="mobile-view mobile-view-title">PDB ID and <br>chain</span>
                                        <span *ngIf="element.afdbAccessions === 'Unavailable'"
                                            >{{ element.targetToShow }} 
                                            <span class="mobile-view"><br></span>  
                                            {{ element.uniprotDescriptions }}
                                        </span>
                            
                                        <span
                                            class="titleBadges"
                                            *ngIf="element.afdbAccessions !== 'Unavailable'">
                                            <a class="pdbid" (click)= "gaService.eventEmitter(
                                        'foldseek_clickthrough', 'FS_similar_structures', 'click', 'foldseek_PDB_url', 'Clicks on PDB URLs in the Foldseek results table')" href="{{element.refLinkId}}" target="_blank">{{ element.targetToShow }}</a>
                                            
                                        </span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="descriptions">
                                        <th class="sec-desc" mat-header-cell *matHeaderCellDef>Description</th>
                                        <td mat-cell *matCellDef="let element">
                                       
                                        <span class="mobile-view mobile-view-title">Description</span>
                                        <span class="mobile-view"> <div class="
                                             moreinfo" appDescription [descriptionData]="element.uniprotDescriptions" [isMobileDesc]="true"> </div> </span>

                                        <div class="nonMobile moreinfo" appDescription [descriptionData]="element.uniprotDescriptions" [isMobileDesc]="false"> </div>
                                       
                                        </td>
                                    </ng-container>
                            
                                    <ng-container matColumnDef="speciesNames">
                                        <th class="third-species" mat-header-cell *matHeaderCellDef>Species</th>
                                        <td mat-cell *matCellDef="let element">
                                       
                                        <span class="mobile-view mobile-view-title">Species</span>
                                        <span class="mobile-view"> <i> <div class=" moreinfo" appDescription [descriptionData]="element.speciesNames" [isMobileDesc]="true"> </div></i> </span>
                                        
                                        <i><div class="nonMobile moreinfo" appDescription [descriptionData]="element.speciesNames" [isMobileDesc]="false"> </div></i>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="sequenceLength">
                                        <th class="fourth-range" mat-header-cell *matHeaderCellDef>
                                            Residue <br/>range
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                        <span class="mobile-view mobile-view-title">Residue range</span>
                                            <div class="moreinforesidue" appResidueRange [residueData]="element.sequenceLength"></div>
                                        </td>
                                    </ng-container>
                            
                                    <ng-container matColumnDef="evalue">
                                        <th class="eval" mat-header-cell *matHeaderCellDef mat-sort-header="evalue">
                                            E-value
                                           
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            <div class="mobile-view mobile-view-title">
                                                <div style="display: flex; flex-direction: row;">
                                                    E-value
                                                  
                                                </div>
                                            </div>
                                            {{ element.evalue }}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="sequenceIdentity">
                                        <th class="seq-identity" mat-header-cell *matHeaderCellDef  mat-sort-header>
                                            <div style="display: flex; flex-direction: row; align-items:end;">
                                                Seq. <br>identity
                                                
                                            </div>
                                           
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="mobile-view mobile-view-title">
                                                <div style="display: flex; flex-direction: row; align-items:end;">
                                                Seq. identity
                                                    
                                                </div>
                                            </span>
                                        {{ element.sequenceIdentity }}%
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="resolution">
                                        <th class="seventh-res thirdid" mat-header-cell *matHeaderCellDef>
                                            Res.
                                            <div style="display: flex;"> (Å)
                                                
                                            </div>
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="mobile-view mobile-view-title"> 
                                                <div style="display: flex; flex-direction: row; align-items: end;">
                                                    Resolution (Å)
                                                    
                                                </div>
                                            </span>
                                            {{ element.resolution }}
                                        </td>
                                    </ng-container>

                                    <!-- <ng-container matColumnDef="alighin3D">
                                        <th class="eight-align" mat-header-cell *matHeaderCellDef>
                                            Align <br/>in 3D
                                        </th>
                                        <td mat-cell *matCellDef="let element" class="align3dfor-nonmobile">
                                            <div class="switch-af nonMobile">
                                                <input type="checkbox" [disabled]="disabledState[element.afdbAccessions.split('*')[0]] || false" [checked]="checkboxState[element.afdbAccessions.split('*')[0]] || false" id="{{element.afdbAccessions.split('*')[0]}}" value="{{element.afdbAccessions.split('*')[0]}}" (change)="superposeSliderToggle($event,element.afdbAccessions.split('*')[0]); $event.stopPropagation();" />
                                                <label (click)="$event.stopPropagation();" for="{{element.afdbAccessions.split('*')[0]}}">
                                                
                                                <img src="../../assets/img/FatX.svg" alt="FatX" class="unchecked-icon">
                                                <img src="../../assets/img/base-switch_icon.svg" alt="check" class="checked-icon">

                                                </label>
                                            </div>
                                        </td>
                                    </ng-container> -->
                                   
                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsStructureWithExpand"></tr>
                                    <tr mat-row *matRowDef="let element; columns: displayedColumnsStructureWithExpand;"
                                        class="example-element-row"
                                        [ngClass]="isExpanded(element) ? 'example-expanded-row' : ''" 
                                        
                                        (click)="expandRow(element)">
                                    </tr>
                                    
                                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                                    
                                    <ng-container *ngFor="let row of pdbStructureDataSource?.data">
                                        <ng-container *ngIf="isExpanded(row)" >
                                          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isExpansionDetailRow" class="example-detail-row"></tr>
                                        </ng-container>
                                    </ng-container>

                                </table>
                                    
                                </div>
                                
                                <div  *ngIf="pdbZeroResultsMsg === ''" class="threedViewer structureContainer">
                                    <p *ngIf="hasPDBData === 1 && totalStructure == 0" class="noRecMsg">{{ errorPDB }}</p>
                                </div>
                                
                                <div *ngIf="pdbZeroResultsMsg === ''">
                                    <mat-paginator
                                        [length]="totalStructure"
                                        [pageSize]="recordsPDB"
                                        [pageIndex]="currentPDBPage"
                                        [pageSizeOptions]="[5, 10, 25, 50, 100]"
                                        aria-label="Select page"
                                        (page)="handlePageEvent($event,'pdb')"
                                    >
                                    </mat-paginator>
                                </div> 
                            </mat-tab>
                            <mat-tab class="mat-tab-title" [label]="''" [disabled]="isAFDBLoading">
                                <ng-template mat-tab-label>
                                  AFDB50 structures&nbsp;
                                  <span *ngIf="!isAFDBLoading">
                                    ({{ totalAFDBStructure }})
                                  </span>
                                  <!-- Spinner shown only when isAFDBLoading is true -->
                                  <span *ngIf="isAFDBLoading"  style="display: inline-block; width: 20px; margin-left: 8px;">
                                    <svg  width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
                                    </svg>
                                  </span>
                                </ng-template>

    
                                <div *ngIf="afdbZeroResultsMsg !== ''" class="threedViewer structureContainer ">
                                    <p *ngIf="hasAFDBData === -1 && totalAFDBStructure == 0" class="noRecMsg">{{ afdbZeroResultsMsg }}</p>
                                </div>
                            
                                <div class="download-first-row" *ngIf="pdbZeroResultsMsg === ''">
                                    <span> Best match displayed first</span>
                                </div>
                                <div *ngIf="afdbZeroResultsMsg === ''">
                                    <table
                                        mat-table
                                        [dataSource]="afdbStructureDataSource"
                                        class="mat-elevation-z8 structureTable"
                                        matSort
                                        matSortActive="evalue"
                                        matSortDirection="desc"
                                        (matSortChange)="sortTable($event, 'afdb')"
                                        matSortDisableClear
                                        multiTemplateDataRows
                                    >

                                    <ng-container matColumnDef="select">
                                        <th mat-header-cell *matHeaderCellDef class="nonMobile">
                                          <input
                                            type="checkbox"
                                            id="select-all-checkbox"
                                            class="vf-form__checkbox"
                                            [checked]="allSelectedAFDB()"
                                            [disabled]="isLimitReachedAFDB"
                                            
                                            (change)="toggleSelectAllEntries($event, 'afdb')"
                                          />
                                          <label for="select-all-checkbox" class="vf-form__label"></label>
                                        </th>
                                        <td mat-cell *matCellDef="let element" class="nonMobile">
                                            <input
                                            type="checkbox"
                                            id="row-checkbox-{{ element.targetToShow }}"
                                            class="vf-form__checkbox"
                                            [checked]="selectionAFDB.has(element.targetToShow)"
                                            [disabled]="isRowCheckboxDisabledAFDB() && !selectionAFDB.has(element.targetToShow)"
                                            (change)="toggleSingleRowSelection($event, element.targetToShow, 'afdb')"
                                          />
                                          <label for="row-checkbox-{{ element.targetToShow }}" class="vf-form__label"></label>
                                        </td>
                                    </ng-container>


                                    <ng-container matColumnDef="expand">
                                        <th  class="firstexpand arrow" mat-header-cell *matHeaderCellDef></th>
                                        <td  mat-cell *matCellDef="let element" class="arrow-box" [ngClass]="!isExpandedAFDB(element) ? '' : 'arrow-active'">
                                            
                                            <div class="mobile-view">
                                                <div class="mobile-wrapfirsttd">
                                                    <button (click)="toggleRowAFDB(element); $event.stopPropagation()"  mat-icon-button aria-label="expand row" class="icon-button">
                                                        <span *ngIf="!isExpandedAFDB(element)" class="mobile-arrow-title-text"> Open pairwise alignment  <img *ngIf="!isExpandedAFDB(element)" src="assets/img/down-arrow.svg" alt="uparrow" class="newimg"></span>
                                                        <span *ngIf="isExpandedAFDB(element)" class="mobile-arrow-title-text"> Close pairwise alignment   <img  src="assets/img/arrow-dropping.svg" alt="downarrow" class="newimg"></span>
    
                                                    </button>
                                                    
                                                </div>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="expandedDetailAFDB">
                                        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsAFDBStructure.length">
                                          <div class="example-element-detail" *ngIf="isExpandedAFDB(element)">
                                            <app-sequence-card [hsps]="element.hsps" [isExpandStructure]="true"></app-sequence-card>
                                          </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="alighin3D">
                                        <th class="fifth alignin3d" mat-header-cell *matHeaderCellDef>
                                            Align <br/>in 3D
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            
                                            <div class="switch-af">
                                                <span class="mobile-view-title">Align in 3D</span>
                                                <input type="checkbox" [disabled]="disabledState[element.afdbAccessions.split('*')[0]] || false" [checked]="checkboxState[element.afdbAccessions.split('*')[0]] || false" id="{{element.afdbAccessions.split('*')[0]}}" value="{{element.afdbAccessions.split('*')[0]}}" (mousedown)="$event.stopPropagation()" 
                                                (click)="$event.stopPropagation()"  (change)="superposeSliderToggle($event,element.afdbAccessions.split('*')[0]); $event.stopPropagation();" />
                                                <label for="{{element.afdbAccessions.split('*')[0]}}">
                                                
                                                <img src="../../assets/img/FatX.svg" alt="FatX" class="unchecked-icon">
                                                <img src="../../assets/img/base-switch_icon.svg" alt="check" class="checked-icon">

                                                </label>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="afdbAccessions">
                                        <th class="first" mat-header-cell *matHeaderCellDef>
                                            <div style="display: flex; align-items: center; flex-direction: row;">
                                                <span> AFDB accession and description</span>
                                            </div> 
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                        <span class="mobile-view mobile-view-title"> AFDB accession and <br>description</span>

                                        <div class="target-desc mobile-view">
                                            <span
                                                class="titleBadges"
                                                *ngIf="element.afdbAccessions !== 'Unavailable'">
                                                <a (click)= "gaService.eventEmitter(
                                            'foldseek_clickthrough', 'FS_similar_structures', 'click', 'foldseek_AFDB_urls', 'Clicks on and AFDB accession URL in the foldseek results table')" class='accessLink' href="{{element.refLinkId}}" target="_blank">{{ element.targetToShow }} </a>
                                                <app-entry-status [isSummary]="false" [clusterTable]="true" [isProteome]="element.afdbAccessions.split('*')[1]" [isReviewed]="element.afdbAccessions.split('*')[2]"></app-entry-status>
                                                
                                            </span>
                                            <div class="descEllipsestrict">
                                                {{  element.uniprotDescriptions }}
                                            </div>
                                        </div>
                                        
                            
                                        <div class="target-desc nonMobile">
                                            <span
                                                class="titleBadges"
                                                *ngIf="element.afdbAccessions !== 'Unavailable'">
                                                <a (click)= "gaService.eventEmitter(
                                            'foldseek_clickthrough', 'FS_similar_structures', 'click', 'foldseek_AFDB_urls', 'Clicks on and AFDB accession URL in the foldseek results table')" class='accessLink' href="{{element.refLinkId}}" target="_blank">{{ element.targetToShow }} </a>
                                                <app-entry-status [isSummary]="false" [clusterTable]="true" [isProteome]="element.afdbAccessions.split('*')[1]" [isReviewed]="element.afdbAccessions.split('*')[2]"></app-entry-status>
                                                
                                            </span>
                                            <div class="label-tooltip" *ngIf="element.uniprotDescriptions.length > 25">
                                        
                                                <p class="descEllipse">{{ element.uniprotDescriptions.slice(0,25) }}... </p>
                                                <span class="label-tooltip-text">
                                                {{  element.uniprotDescriptions }}
                                                </span>
                                            </div>
                                
                                            <div *ngIf="element.uniprotDescriptions.length <= 25" class="descEllipsestrict">
                                                {{  element.uniprotDescriptions }}
                                            </div>
                                        </div>
                                    </td>
                                    </ng-container>
                            
                                    <ng-container matColumnDef="speciesNames">
                                        <th class="third-species" mat-header-cell *matHeaderCellDef>Species</th>
                                        <td mat-cell *matCellDef="let element">
                                       
                                        <span class="mobile-view mobile-view-title">Species</span>
                                        <span class="mobile-view"> <i>{{  element.speciesNames }}</i> </span>
                                        
                                        <span class="nonMobile">
                                            <div class="label-tooltip" *ngIf="element.speciesNames.length > 20">
                                           
                                                <p class="descEllipseSpec"><i>{{ element.speciesNames.slice(0,20) }}... </i> </p>
                                                <span class="label-tooltip-text">
                                                {{  element.speciesNames }}
                                                </span>
                                            </div>
                                
                                            <div *ngIf="element.speciesNames.length <= 20">
                                                <p class="descEllipseSpec-norm"><i> {{  element.speciesNames }}</i></p>
                                            </div>
                                        </span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="sequenceLength">
                                        <th class="fourth" mat-header-cell *matHeaderCellDef>
                                        Residue <br/>range
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                        <span class="mobile-view mobile-view-title">Residue range</span>
                                        {{ element.sequenceLength }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="evalue">
                                        <th class="eval" mat-header-cell *matHeaderCellDef mat-sort-header="evalue">
                                            E-value
                                           
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="mobile-view mobile-view-title">
                                                <div style="display: flex; flex-direction: row;">
                                                    E-value
                                                   
                                                </div>
                                            </span>
                                            {{ element.evalue }}
                                        </td>
                                    </ng-container>
                            
                                    <ng-container matColumnDef="sequenceIdentity">
                                        <th class="fourth thirdid" mat-header-cell *matHeaderCellDef  mat-sort-header>
                                            <div style="display: flex; flex-direction: row; align-items:end;">
                                                Seq. <br> identity
                                                
                                            </div>
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                        <span class="mobile-view mobile-view-title">
                                            <div style="display: flex; flex-direction: row; align-items:end;">
                                            Seq. identity
                                               
                                            </div>
                                        </span>
                                        {{ element.sequenceIdentity }}%
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="averagePlddt">
                                        <th class="fifth" mat-header-cell *matHeaderCellDef>
                                        Average <br/>pLDDT
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                        <span class="mobile-view mobile-view-title"> Average pLDDT</span>
                                        {{ element.averagePlddt }}
                                        </td>
                                    </ng-container>
                                
                                   
                            
                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsAFDBStructure"></tr>
                                    <tr mat-row *matRowDef="let element; columns: displayedColumnsAFDBStructure;"
                                        class="example-element-row"
                                        [ngClass]="isExpandedAFDB(element) ? 'example-expanded-row' : ''" 
                                        
                                        (click)="expandRowAFDB(element)">
                                    </tr>
                                  
                                    <tr mat-row *matRowDef="let row; columns: ['expandedDetailAFDB']" class="example-detail-row"></tr>
                
                                    <ng-container *ngFor="let row of afdbStructureDataSource?.data">
                                        <ng-container *ngIf="isExpandedAFDB(row)" >
                                          <tr mat-row *matRowDef="let row; columns: ['expandedDetailAFDB']; when: isExpansionDetailRowAFDB" class="example-detail-row"></tr>
                                        </ng-container>
                                      </ng-container>
                                    </table>
                                
                                </div>
                               
                                <div  *ngIf="afdbZeroResultsMsg === ''" class="threedViewer structureContainer mobile-error-msg fullwidth">
                                    <p *ngIf="hasAFDBData === 1 && totalAFDBStructure == 0" class="noRecMsg">{{ errorAFDB }}</p>
                                </div>
                                
                                <div *ngIf="afdbZeroResultsMsg === ''" [ngClass]="errorAFDB ? 'nonMobile' : ''">
                                    <mat-paginator
                                    [length]="totalAFDBStructure"
                                    [pageSize]="recordsAFDB"
                                    [pageIndex]="currentAFDBPage"
                                    [pageSizeOptions]="[5, 10, 25, 50, 100]"
                                    aria-label="Select page"
                                    (page)="handlePageEvent($event,'afdb')"
                                  >
                                  </mat-paginator>
                                </div>
                               
                            </mat-tab>
                        </mat-tab-group>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>  


    <div *ngIf="!downloadService.isDownloadRunningPDB() && downloadService.isDownloadFailedPDB()"> 
        <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText="Download failed due to a technical issue. Please refresh and try again." messageType="error">
        </app-status-message>
    </div>

    <div *ngIf="!downloadService.isDownloadRunningPDB() && !downloadService.isDownloadFailedPDB() && downloadService.isDownloadDonePDB()"> 
        <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText="Download successful. <br />If the download pop-up doesn’t appear, please enable pop-ups in your browser’s Privacy and Security settings." messageType="success">
        </app-status-message>
    </div>

    <div *ngIf="!downloadService.isDownloadRunningAFDB() && downloadService.isDownloadFailedAFDB()"> 
        <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText="Download failed due to a technical issue. Please refresh and try again." messageType="error">
        </app-status-message>
    </div>

    <div *ngIf="!downloadService.isDownloadRunningAFDB() && !downloadService.isDownloadFailedAFDB() && downloadService.isDownloadDoneAFDB()"> 
        <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText='Download successful. <br/> If the download pop-up doesn’t appear, please enable pop-ups in your browser’s Privacy and Security settings.' messageType="success">
        </app-status-message>
    </div>
   
    <div class="empty-stage-box"  *ngIf="!isStructureRunning && !isStructureFail && (isPDBFoldseekCach === false || isAFDBFoldseekCach === false) ">
        <div class="frame-parent">
            <div class="be-the-first-to-explore-parent">
                <div class="be-the-first">Explore similar structures</div>
                <div class="it-appears-that paeDescription">Structure search is powered by Foldseek, a tool for fast protein structure comparison. <br>
                    Start a structural similarity search to discover similar proteins.</div>
            </div>
            <div class="button">
                <a  class="vf-button vf-button--secondary vf-button--sm" style="color: #3B6FB6"
                    (click)="startStructureSearch()">
                    Find similar structures
                </a>
               
            </div>
        </div>
    </div>  
  
    <div class="empty-stage-box" *ngIf="isStructureRunning && !isStructureFail && hasAFDBData == -1">
        <div class="frame-parent">
            <div class="be-the-first-to-explore-parent">
                <div class="be-the-first">Structure similarity search in progress</div>
                <div class="it-appears-that">The Foldseek structure similarity search is currently in progress. <br/>Please stand by, the search usually takes a few minutes to complete.</div>
            </div>
            <div>
                <svg style="display: block;" width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
                </svg>
            </div>
        </div>
    </div>  

     
    <div class="empty-stage-box"  *ngIf="isStructureCach === true && !isStructureRunning && (hasPDBData == -1 && isPDBLoading === false) && (hasAFDBData == -1 && isAFDBLoading === false) && !isStructureFail">
        <div class="frame-parent">
            <div class="be-the-first-to-explore-parent">
                <div class="be-the-first">No similar structures found</div>
                <div class="it-appears-that">It seems there are no similar structures found in PDB and AFDB.</div>
            </div>
        </div>
    </div>  

    <div class="empty-stage-box" *ngIf="isStructureFail && (hasPDBData == -1 && isPDBLoading === false) && (hasAFDBData == -1 && isAFDBLoading === false)">
        <div class="frame-parent">
            <div class="be-the-first-to-explore-parent">
                <div class="be-the-first">Search error</div>
                <div class="it-appears-that">An error occurred while processing your Foldseek structure similarity search. Please try again later or contact us at afdbhelp&#64;ebi.ac.uk if the error persists.</div>
            </div>
            <div class="button">
                <a  class="vf-button vf-button--secondary vf-button--sm" style="color: #3B6FB6"
                    (click)="startStructureSearch()"
                    target="_blank">
                    Find similar structures
                </a>
            </div>
        </div>
    </div> 
</div>